import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AddAppointmentModal from '../appointmentmanagment/addappointment'; // Le composant modal
import {
    CButton,
    CRow,
    CCol,
    CCard,
    CCardBody,
    CHeader, CContainer, CHeaderNav, CNavItem, CNavLink,
} from '@coreui/react';
import { FaArrowLeft } from "react-icons/fa";
import { BsPersonPlus, BsChevronRight } from 'react-icons/bs';
import '../../../assets/css/mainstyle.css';
import axios from 'axios';

import Adminprofil from '../../../assets/images/adminprofil.png';
import folderempty from '../../../assets/images/Group 207.png';
import api from '../../../service/caller';
const styles = {
    container: {
        padding: '1.5rem',
        minHeight: '100vh'
    },
    card: {
        backgroundColor: 'white',
        borderRadius: '0.5rem',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
        padding: '1.5rem'
    },
    title: {
        color: '#2563EB',
        fontSize: '42px',
        fontWeight: 'bold',
        marginBottom: '1.5rem'
    },
    backButton: {
        display: 'flex',
        alignItems: 'center',
        color: '#2563EB',
        border: 'solid blue 2px',
        background: 'none',
        cursor: 'pointer',
        borderRadius: "15px",
        height: "50px",
        width: "100px",
        marginBottom: '1.5rem'
    },
    sectionTitle: {
        borderLeft: '4px solid #22C55E',
        paddingLeft: '1rem',
        marginBottom: '0.5rem'
    },
    sectionTitleText: {
        fontSize: "18px",
        color: '#4B5563',
        fontWeight: '500'
    },
    gridContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gap: '1rem',
        marginTop: '1rem',
        marginBottom: '2rem'
    },
    label: {
        color: '#4B5563',
        fontSize: '0.875rem',
        marginBottom: '0.25rem'
    },
    value: {
        fontWeight: 'bold'
    },
    tableContainer: {
        backgroundColor: '#28A7452B',
        borderRadius: '0.5rem',
        padding: '1rem'
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse'
    },
    th: {
        textAlign: 'left',
        paddingBottom: '1rem',
        color: '#4B5563',
        fontSize: '0.875rem',
        fontWeight: 'normal'
    },
    td: {
        padding: '0.5rem 0',
        color: '#374151'
    }
};

const Patientfilemedical = () => {
    const [visible, setVisible] = useState(false);
    const [appointments, setAppointments] = useState([]);
    const [ticket, setticket] = useState(false);
    const { patientId } = useParams();
    const [patientData, setPatientData] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [medicalHistories, setMedicalHistory] = useState([]);
    const [selectedConsultation, setSelectedConsultation] = useState(null); // État pour les détails de la consultation
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPatientData = async () => {
            try {
                const response = await api.get(`/clinic/getpatient/${patientId}`);
                setPatientData(response.data);
            } catch (error) {
                console.error('Erreur lors de la récupération des données du patient:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchPatientData();
    }, [patientId]);

    useEffect(() => {
        async function fetchMedicalHistory() {
            try {
                const response = await api.get(`clinic/medicalhistory/${patientId}`);
                setMedicalHistory(response.data);
                setLoading(false);
            } catch (error) {
                setError('Une erreur est survenue lors de la récupération de l\'historique médical.');
                setLoading(false);
            }
        }

        fetchMedicalHistory();
    }, [patientId]);

    const handleAppointmentAdded = (newAppointment) => {
        setAppointments((prev) => [...prev, newAppointment]);
    };

    // const handleViewDetails = (consultation) => {
    //     setSelectedConsultation(consultation); // Sélectionner la consultation à afficher
    // };

    if (loading) {
        return <p>Chargement...</p>;
    }

    // Patientfilemedical.js
    const handleViewDetails = (medicalHistorie) => {
        // Récupérer l'ID de la consultation depuis medicalHistorie
        const consultationId = medicalHistorie.ConsultationId._id;
        
        // Naviguer vers la page des détails de la consultation
        navigate(`/hospitaladmin/consultation-details/${consultationId}`);
    };
    

    return (
        <div className="dashboard-header">
            <CHeader position="sticky" style={{ backgroundColor: '#DFEAF5' }}>
                <CContainer fluid className="d-flex align-items-center">
                    <div className='row w-100'>
                        <div className="pagetittle col">
                            <h4><b>Patient Management</b></h4>
                            <p>Home <BsChevronRight className='mx-2' style={{ fontSize: "12px" }} />  Dashboard <BsChevronRight style={{ fontSize: "12px" }} className='mx-2' />  <span style={{ color: '#191B1C' }}>Patient Management</span></p>
                        </div>
                        <div className=' d-flex col justify-content-end'>
                            <CHeaderNav>
                                <CNavItem>
                                    <CNavLink href="#" className="d-flex align-items-center ms-auto">
                                        <img src={Adminprofil} className='cardicon' alt="Consultation Icon" width={'50'} height={'50'} />
                                        <div>
                                            <span className="ms-2">Semia BOKO</span>
                                            <p className="ms-2">Admin</p>
                                        </div>
                                    </CNavLink>
                                </CNavItem>
                            </CHeaderNav>
                        </div>
                    </div>
                </CContainer>
            </CHeader>

            <div className="Patientlist filemedical mt-2">
                <div className='tabsection'>
                    <CRow>
                        <CCol xs={12}>
                            <CCard className="card mb-4 p-4">
                                <CCardBody>
                                    <div className='topbtn'>
                                        <div className="retourbtn">
                                            <CButton className="retourbtn" onClick={() => (navigate(-1) || navigate('/'))}>
                                                <FaArrowLeft /> Retour
                                            </CButton>
                                        </div>

                                        <div className='registeruserbtn ms-auto'>
                                            <CButton onClick={() => setVisible(!visible)} className="registernewbtn ms-auto d-flex align-items-center" active tabIndex={-1}>
                                                <BsPersonPlus className='mx-2' /> New Appointment
                                            </CButton>
                                        </div>
                                    </div>

                                    <AddAppointmentModal
                                        visible={visible}
                                        onClose={() => setVisible(false)}
                                        onAppointmentAdded={handleAppointmentAdded} patientId={patientId} patientfirstName={patientData.firstname} patientlastName={patientData.lastname}
                                    />

                                    <div className='patientdetails'>
                                        <div className='d-flex align-items-center cardheader mb-5'>
                                            <span className='me-3' style={{ width: '70px', height: '5px', background: 'green' }}></span>
                                            <h4>Medical history</h4>
                                        </div>

                                        {patientData ? (
                                            <CRow className="my-3 patientinfo mb-5">
                                                <CCol xs={12} md={2}>
                                                    <div className="flexcoldisposition">
                                                        <p>Name :</p>
                                                        <p><b>{patientData.firstname} {patientData.lastname}</b></p>
                                                    </div>
                                                </CCol>
                                                <CCol xs={12} md={2}>
                                                    <div className="flexcoldisposition">
                                                        <p>Email : </p>
                                                        <p><b>{patientData.email}</b></p>
                                                    </div>
                                                </CCol>
                                                <CCol xs={12} md={2}>
                                                    <div className="flexcoldisposition">
                                                        <p>Date of birth: </p>
                                                        <p><b>{patientData.age.split("T")[0]}</b></p>
                                                    </div>
                                                </CCol>
                                                <CCol xs={12} md={2}>
                                                    <div className="flexcoldisposition">
                                                        <p>Address : </p>
                                                        <p><b>{patientData.address}</b></p>
                                                    </div>
                                                </CCol>
                                                <CCol xs={12} md={2}>
                                                    <div className="flexcoldisposition">
                                                        <p>Gender :</p>
                                                        <p><b>{patientData.gender}</b></p>
                                                    </div>
                                                </CCol>
                                            </CRow>

                                        ) : (
                                            <p>No data available</p>
                                        )}
                                    </div>

                                    <div className='mt-5'>
                                        <div className='d-flex align-items-center cardheader'>
                                            <span className='me-3' style={{ width: '70px', height: '5px', background: 'green' }}></span>
                                            <h4>Medical history</h4>
                                        </div>

                                        {medicalHistories ? (
                                            <div style={styles.tableContainer}>
                                                <table style={styles.table}>
                                                    <thead>
                                                        <tr>
                                                            <th className='text-center' style={styles.th}>#</th>
                                                            <th className='text-center' style={styles.th}>Last Visit</th>
                                                            <th className='text-center' style={styles.th}>Type</th>
                                                            <th className='text-center' style={styles.th}>Doctor</th>
                                                            <th className='text-center' style={styles.th}>Services</th>
                                                            <th className='text-center' style={styles.th}>Voir détails</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {medicalHistories.map((medicalHistorie) => (
                                                            <tr key={medicalHistorie.id}>
                                                                <td className='text-center' style={styles.td}>{medicalHistorie.id}</td>
                                                                <td className='text-center' style={styles.td}>{new Date(medicalHistorie?.consultationDate).toISOString().split('T')[0]}</td>
                                                                <td className='text-center' style={styles.td}>{medicalHistorie.AppointmentId.motif}</td>
                                                                <td className='text-center' style={styles.td}>{medicalHistorie.ConsultationId.doctorId}</td>
                                                                <td className='text-center' style={styles.td}>{medicalHistorie.ConsultationId.services.map(service => service.name).join(', ')}</td>
                                                                {/* <td className='text-center text-success' style={styles.td}>
                                                                    <i className="bi bi-eye" onClick={() => handleViewDetails(medicalHistorie)}></i>
                                                                </td> */}
                                                                <td className='text-center text-success' style={styles.td}>
                                                                    <i className="bi bi-eye" onClick={() => handleViewDetails(medicalHistorie)} style={{ cursor: 'pointer' }}></i>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        ) : (
                                            <div className='d-flex align-items-center justify-content-center' style={{ height: '300px' }}>
                                                <h4>No medical history yet</h4>
                                                <img src={folderempty} className='cardicon' alt="Consultation Icon" width={'100'} height={'100'} />
                                            </div>
                                        )}
                                    </div>

                                    {/* Affichage des détails de la consultation sélectionnée */}
                                    {selectedConsultation && (
                                        <div className="detailSection">
                                            <h5>Details for Consultation ID: {selectedConsultation.id}</h5>
                                            <p><strong>Date of Consultation:</strong> {new Date(selectedConsultation?.consultationDate).toISOString().split('T')[0]}</p>
                                            <p><strong>Doctor:</strong> {selectedConsultation.ConsultationId.doctorId}</p>
                                            <p><strong>Services:</strong> {selectedConsultation.ConsultationId.services.map(service => service.name).join(', ')}</p>
                                            <p><strong>Notes:</strong> {selectedConsultation.ConsultationId.notes || 'No notes available'}</p>
                                        </div>
                                    )}
                                </CCardBody>
                            </CCard>
                        </CCol>
                    </CRow>
                </div>
            </div>
        </div>
    );
};

export default Patientfilemedical;
